// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"d2bf67bd","448":"273f4d67","865":"52e3dbfc"}[chunkId] + ".chunk.js";
};